import { 
    GET_GRILLA_IMPLICADO,
    GET_DATOS_PANTALLA,
    GET_COMBO_SEGURO,
    GET_COMBO_COMPANIAS,
    GET_COMBO_VEHICULOS,
    GET_COMBO_MARCAS,
    GET_COMBO_PAIS,
    GET_COMBO_COMUNAS,
    POST_ACTUALIZAR_IMPLICADO,
    OBTENER_DATOS_NO_FORMATOS,
    OBTENER_RUT_CONDUCTOR,
    OBTENER_RUT_PROPIETARIO,
    GET_PARAMETROS

 
} from '../types';

export default function implicadoReducer(state = {}, action) {
    switch (action.type) {
        case GET_GRILLA_IMPLICADO:
            return { ...state, grillaImplicado:action.payload }
        case GET_PARAMETROS:
            return { ...state, parametros:action.payload }
    
        case GET_DATOS_PANTALLA:
            return { ...state, datosPantalla:action.payload }
        case GET_COMBO_SEGURO:
            return { ...state, comboSeguro:action.payload }
        case GET_COMBO_COMPANIAS:
            return { ...state, comboCompanias:action.payload }
        case GET_COMBO_VEHICULOS:
            return { ...state, comboVehiculos:action.payload }
        case GET_COMBO_MARCAS:
            return { ...state, comboMarcas:action.payload }
    
        case GET_COMBO_PAIS:
            return { ...state, comboPais:action.payload }
        case GET_COMBO_COMUNAS:
            return { ...state, comboComunas:action.payload }
        case POST_ACTUALIZAR_IMPLICADO:
            return { ...state, respuestaImplicado:action.payload }
        case OBTENER_DATOS_NO_FORMATOS:
            return { ...state, datosNoFormatos:action.payload }
        case OBTENER_RUT_CONDUCTOR:
            return { ...state, rutConductor:action.payload }
        case OBTENER_RUT_PROPIETARIO:
            return { ...state, rutPropietario:action.payload }
    
       
        default:
            return state
    }
}